/**
 * Recover from stale JS chunks after the app was idle, a tab was discarded,
 * or a new deploy landed while the PWA was still open.
 */

const MODULE_LOAD_ERROR_RE =
  /Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Component load timeout/i;

const STALE_CHUNK_RELOAD_KEY = 'persianist-stale-chunk-reload-at';

let errorBoundaryActiveUntil = 0;

export function isModuleLoadError(error: unknown): boolean {
  if (!error) return false;
  const name = error instanceof Error ? error.name : '';
  const message = error instanceof Error ? error.message : String(error);
  return name === 'ChunkLoadError' || MODULE_LOAD_ERROR_RE.test(message);
}

export function markReactErrorBoundaryCaught(): void {
  errorBoundaryActiveUntil = Date.now() + 2500;
}

export function isReactErrorBoundaryHandling(): boolean {
  return Date.now() < errorBoundaryActiveUntil;
}

/** Reload once so a rejected React.lazy() promise cannot brick the session. */
export function reloadOnceForStaleChunk(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const last = Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY) || '0');
    if (Number.isFinite(last) && Date.now() - last < 15_000) {
      return false;
    }
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    /* sessionStorage may be unavailable */
  }
  window.location.reload();
  return true;
}
